import instance from '../utils/axios';

const WB_API_BASE = 'https://xtool-wb.gson.workers.dev';

export const whiteboardApi = {
    listBoards() {
        return instance.get(`${WB_API_BASE}/wb/list`);
    },

    getBoard(id) {
        return instance.get(`${WB_API_BASE}/wb/${id}`);
    },

    createBoard(data) {
        return instance.post(`${WB_API_BASE}/wb`, data);
    },

    updateBoard(id, data) {
        return instance.put(`${WB_API_BASE}/wb/${id}`, data);
    },

    deleteBoard(id) {
        return instance.delete(`${WB_API_BASE}/wb/${id}`);
    }
};

export default whiteboardApi;
